import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('@@TAP/profiling');
export const getProfile = actionCreator.async('GET_USER_PROFILE');
export const fetchUserPermissions = actionCreator.async('FETCH_USER_PERMISSIONS');
export const getCompany = actionCreator.async('GET_USER_COMPANY');
export const setUserProfileLoaded = actionCreator('SET_USER_PROFILE_LOADED');
export const fetchUserApps = actionCreator.async('FETCH_USER_APPS');
export const fetchTenantsSettings = actionCreator.async('FETCH_TENANTS_SETTINGS');
export const updateUserProfile = actionCreator.async('UPDATE_USER_PROFILE');
export const updateCompany = actionCreator.async('UPDATE_COMPANY');
export const addUser = actionCreator.async('ADD_COMPANY');
export const retryMutationOnCompany = actionCreator('RETRY_UPDATE_COMPANY');
export const retryMutationOnCompanySelectedRule = actionCreator('RETRY_UPDATE_COMPANY_SELECTED_RULE');
export const retryMutationOnCompanyCancel = actionCreator('RETRY_UPDATE_COMPANY_CANCEL');
//# sourceMappingURL=profiling.actions.js.map